import { FaDollarSign, FaUser, FaStoreAlt, FaChartBar, FaCog, FaHandHoldingUsd } from 'react-icons/fa'
import { IoReader } from 'react-icons/io5'
import { BANKING_ENABLED } from 'services/features'

const NavbarData = [
  {
    label: 'Financeiro',
    id: 'financial',
    path: '/admin',
    icon: <FaDollarSign/>
  },
  {
    label: 'Membros',
    id: 'members',
    path: '/admin/members',
    icon: <FaUser/>
  },
  {
    label: 'Salões',
    id: 'businesses',
    path: '/admin/businesses',
    icon: <FaStoreAlt/>
  },
  {
    label: 'Dashboard',
    id: 'dashboard',
    path: '/admin/dashboard',
    icon: <FaChartBar/>
  },
  /*
    O repasse automático faz parte do Cutilei Pay, que ainda não foi lançado: em produção o
    item não entra na navbar. Ver `services/features.js`.
  */
  ...(BANKING_ENABLED ? [{
    label: 'Repasse automático',
    id: 'payouts',
    path: '/admin/payouts',
    icon: <FaHandHoldingUsd/>
  }] : []),
  {
    label: 'Logs de auditoria',
    id: 'audit_logs',
    path: '/admin/audit_logs',
    icon: <IoReader/>
  },
  {
    label: 'Configurações',
    id: 'config',
    path: '/admin/config',
    icon: <FaCog/>
  },
]

export default NavbarData
